import type { AxiosInstance } from "axios";
import { logger } from "./logger";

// Attach standardized HTTP error logging to an axios instance
export function attachHttpLogging(instance: AxiosInstance, name: string) {
  instance.interceptors.response.use(
    (res) => res,
    (err) => {
      const meta = {
        client: name,
        url: err.config?.url ?? null,
        method: err.config?.method ?? null,
        status: err.response?.status ?? null,
        statusText: err.response?.statusText ?? null,
        code: err.code ?? null,
        message: err.message ?? null,
        // امن: هیچ body ای لاگ نمی‌شود
        headers: {
          "x-request-id": err.response?.headers?.["x-request-id"] ?? null,
        },
      };
      logger.error("HTTP request failed", meta);
      return Promise.reject(err);
    }
  );
}

